/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedQuery<InputType, OutputType> = string & {
    __generatedQueryInput: InputType;
    __generatedQueryOutput: OutputType;
};

export const authLink = /* GraphQL */ `query AuthLink($input: AuthLinkInput!) {
  authLink(input: $input) {
    foreignId
    amount
    link
    provider
    __typename
  }
}
` as GeneratedQuery<APITypes.AuthLinkQueryVariables, APITypes.AuthLinkQuery>;
export const authUrl = /* GraphQL */ `query AuthUrl($input: AuthUrlInput!) {
  authUrl(input: $input) {
    gotoUrl
    gotoUrlQr
    __typename
  }
}
` as GeneratedQuery<APITypes.AuthUrlQueryVariables, APITypes.AuthUrlQuery>;
export const callback = /* GraphQL */ `query Callback($paymentId: String, $url: String!) {
  callback(paymentId: $paymentId, url: $url) {
    success
    transferId
    gotoUrl
    __typename
  }
}
` as GeneratedQuery<APITypes.CallbackQueryVariables, APITypes.CallbackQuery>;
export const checkIsGroupMember = /* GraphQL */ `query CheckIsGroupMember($checkInput: CheckIsGroupMemberInput!) {
  checkIsGroupMember(checkInput: $checkInput) {
    group {
      bills {
        amount
        createdAt
        createdBy
        currency
        groupId
        id
        name
        owings {
          amount
          avatarUrl
          currency
          firstName
          id
          narwhalId
          username
          __typename
        }
        __typename
      }
      createdAt
      id
      imageUrl
      members {
        avatarUrl
        firstName
        groupCreator
        groupId
        id
        narwhalId
        username
        __typename
      }
      name
      __typename
    }
    groupId
    isGroupMember
    __typename
  }
}
` as GeneratedQuery<
    APITypes.CheckIsGroupMemberQueryVariables,
    APITypes.CheckIsGroupMemberQuery
>;
export const claimedItemsCustomer = /* GraphQL */ `query ClaimedItemsCustomer {
  claimedItemsCustomer {
    claimId
    claimerEmail
    claimerName
    claimerNarwhalId
    createdAt
    image
    isPopped
    merchantName
    merchantNarwhalId
    name
    poppedAt
    shortCode
    variantId
    __typename
  }
}
` as GeneratedQuery<
    APITypes.ClaimedItemsCustomerQueryVariables,
    APITypes.ClaimedItemsCustomerQuery
>;
export const claimedItemsMerchant = /* GraphQL */ `query ClaimedItemsMerchant {
  claimedItemsMerchant {
    claimId
    claimerEmail
    claimerName
    claimerNarwhalId
    createdAt
    image
    isPopped
    merchantName
    merchantNarwhalId
    name
    poppedAt
    shortCode
    variantId
    __typename
  }
}
` as GeneratedQuery<
    APITypes.ClaimedItemsMerchantQueryVariables,
    APITypes.ClaimedItemsMerchantQuery
>;
export const companyByNarwhal = /* GraphQL */ `query CompanyByNarwhal($narwhalId: String!) {
  companyByNarwhal(narwhalId: $narwhalId) {
    logo
    name
    __typename
  }
}
` as GeneratedQuery<
    APITypes.CompanyByNarwhalQueryVariables,
    APITypes.CompanyByNarwhalQuery
>;
export const companyByUsername = /* GraphQL */ `query CompanyByUsername($username: String!) {
  companyByUsername(username: $username) {
    logo
    name
    __typename
  }
}
` as GeneratedQuery<
    APITypes.CompanyByUsernameQueryVariables,
    APITypes.CompanyByUsernameQuery
>;
export const connections = /* GraphQL */ `query Connections($connectionsInput: ConnectionsQueryInput!) {
  connections(connectionsInput: $connectionsInput) {
    connections {
      customerId
      customerName
      customerPhoto
      purchases {
        amount
        id
        note
        time
        __typename
      }
      totalSpend
      totalVisits
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
    APITypes.ConnectionsQueryVariables,
    APITypes.ConnectionsQuery
>;
export const entityByNarwhal = /* GraphQL */ `query EntityByNarwhal($narwhalId: String!) {
  entityByNarwhal(narwhalId: $narwhalId) {
    enabled
    features {
      cardsSettings
      guestCheckout
      hasCards
      hasIBAN
      hasTipping
      __typename
    }
    logo
    name
    narwhalId
    type
    __typename
  }
}
` as GeneratedQuery<
    APITypes.EntityByNarwhalQueryVariables,
    APITypes.EntityByNarwhalQuery
>;
export const getAgreement = /* GraphQL */ `query GetAgreement($id: String!) {
  getAgreement(id: $id) {
    id
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetAgreementQueryVariables,
    APITypes.GetAgreementQuery
>;
export const getAgreementFromForeignId = /* GraphQL */ `query GetAgreementFromForeignId($foreignId: String!) {
  getAgreementFromForeignId(foreignId: $foreignId) {
    acceptorNarwhal {
      companyEntityType
      companyLogoUrl
      companyName
      individualAvatarUrl
      individualName
      username
      __typename
    }
    attribute
    id
    initiatorNarwhal {
      companyEntityType
      companyLogoUrl
      companyName
      individualAvatarUrl
      individualName
      username
      __typename
    }
    transfer {
      amount
      authUrl {
        gotoUrl
        gotoUrlQr
        __typename
      }
      currency
      date
      details {
        avatar
        companyPreferences {
          guestCheckout
          __typename
        }
        name
        type
        __typename
      }
      direction
      id
      isAccepted
      isError
      isInitiated
      isSettled
      note
      ownerNarwhalId
      serviceProviderName
      statementReference
      status
      vatAmount
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetAgreementFromForeignIdQueryVariables,
    APITypes.GetAgreementFromForeignIdQuery
>;
export const getAgreementFromTransferId = /* GraphQL */ `query GetAgreementFromTransferId($transferId: String!) {
  getAgreementFromTransferId(transferId: $transferId) {
    acceptorNarwhal {
      companyEntityType
      companyLogoUrl
      companyName
      individualAvatarUrl
      individualName
      username
      __typename
    }
    attribute
    id
    initiatorNarwhal {
      companyEntityType
      companyLogoUrl
      companyName
      individualAvatarUrl
      individualName
      username
      __typename
    }
    transfer {
      amount
      authUrl {
        gotoUrl
        gotoUrlQr
        __typename
      }
      currency
      date
      details {
        avatar
        companyPreferences {
          guestCheckout
          __typename
        }
        name
        type
        __typename
      }
      direction
      id
      isAccepted
      isError
      isInitiated
      isSettled
      note
      ownerNarwhalId
      serviceProviderName
      statementReference
      status
      vatAmount
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetAgreementFromTransferIdQueryVariables,
    APITypes.GetAgreementFromTransferIdQuery
>;
export const getBasket = /* GraphQL */ `query GetBasket($basketId: String!) {
  getBasket(basketId: $basketId) {
    currency
    displayTotal
    id
    items {
      addedAt
      currency
      displayPrice
      name
      price
      quantity
      shortCode
      updatedAt
      variantId
      vatAmount
      __typename
    }
    total
    __typename
  }
}
` as GeneratedQuery<APITypes.GetBasketQueryVariables, APITypes.GetBasketQuery>;
export const getCustomerNotes = /* GraphQL */ `query GetCustomerNotes($customerNarwhalId: String!) {
  getCustomerNotes(customerNarwhalId: $customerNarwhalId) {
    notes {
      content
      createdAt
      customerNarwhalId
      id
      summary
      title
      updatedAt
      __typename
    }
    success
    warnings
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetCustomerNotesQueryVariables,
    APITypes.GetCustomerNotesQuery
>;
export const getInvoice = /* GraphQL */ `query GetInvoice($id: String!, $narwhalId: String) {
  getInvoice(id: $id, narwhalId: $narwhalId) {
    createdAt
    customerNarwhalId
    dueDate
    invoiceNumber
    issueDate
    merchantNarwhalId
    orderItems
    payee {
      accountNumber
      address
      email
      id
      name
      sortCode
      username
      __typename
    }
    payer {
      address
      email
      id
      name
      __typename
    }
    subtotal
    totalAmount
    totalVAT
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetInvoiceQueryVariables,
    APITypes.GetInvoiceQuery
>;
export const getMerchantInvoices = /* GraphQL */ `query GetMerchantInvoices($input: GetMerchantInvoicesInput) {
  getMerchantInvoices(input: $input) {
    invoices {
      createdAt
      customerNarwhalId
      dueDate
      invoiceNumber
      issueDate
      merchantNarwhalId
      orderItems
      payee {
        accountNumber
        address
        email
        id
        name
        sortCode
        username
        __typename
      }
      payer {
        address
        email
        id
        name
        __typename
      }
      subtotal
      totalAmount
      totalVAT
      updatedAt
      __typename
    }
    success
    warnings
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetMerchantInvoicesQueryVariables,
    APITypes.GetMerchantInvoicesQuery
>;
export const getNarwhalFromIdentity = /* GraphQL */ `query GetNarwhalFromIdentity($cognitoId: String!) {
  getNarwhalFromIdentity(cognitoId: $cognitoId)
}
` as GeneratedQuery<
    APITypes.GetNarwhalFromIdentityQueryVariables,
    APITypes.GetNarwhalFromIdentityQuery
>;
export const getNotificationsEmail = /* GraphQL */ `query GetNotificationsEmail {
  getNotificationsEmail {
    narwhalId
    paymentNotificationEmails
    paymentNotificationPush {
      endpoint
      keys {
        auth
        p256dh
        __typename
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetNotificationsEmailQueryVariables,
    APITypes.GetNotificationsEmailQuery
>;
export const getPayment = /* GraphQL */ `query GetPayment($id: String!) {
  getPayment(id: $id) {
    amount
    id
    note
    paymentQrSrc
    paymentUrl
    status
    transferId
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetPaymentQueryVariables,
    APITypes.GetPaymentQuery
>;
export const getPayments = /* GraphQL */ `query GetPayments($input: GetPaymentsInput) {
  getPayments(input: $input) {
    items {
      amount
      authUrl {
        gotoUrl
        gotoUrlQr
        __typename
      }
      currency
      date
      details {
        avatar
        companyPreferences {
          guestCheckout
          __typename
        }
        name
        type
        __typename
      }
      direction
      id
      isAccepted
      isError
      isInitiated
      isSettled
      note
      ownerNarwhalId
      serviceProviderName
      statementReference
      status
      vatAmount
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetPaymentsQueryVariables,
    APITypes.GetPaymentsQuery
>;
export const getRequest = /* GraphQL */ `query GetRequest($requestId: String!) {
  getRequest(requestId: $requestId) {
    amount
    createdAt
    currency
    id
    narwhalId
    note
    status
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetRequestQueryVariables,
    APITypes.GetRequestQuery
>;
export const getRequests = /* GraphQL */ `query GetRequests {
  getRequests {
    items {
      amount
      createdAt
      currency
      id
      narwhalId
      note
      status
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetRequestsQueryVariables,
    APITypes.GetRequestsQuery
>;
export const getStripeBalance = /* GraphQL */ `query GetStripeBalance($input: GetStripeBalanceInput) {
  getStripeBalance(input: $input) {
    available
    nextPayout
    pending
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetStripeBalanceQueryVariables,
    APITypes.GetStripeBalanceQuery
>;
export const getTransfer = /* GraphQL */ `query GetTransfer($id: String!) {
  getTransfer(id: $id) {
    amount
    authUrl {
      gotoUrl
      gotoUrlQr
      __typename
    }
    currency
    date
    details {
      avatar
      companyPreferences {
        guestCheckout
        __typename
      }
      name
      type
      __typename
    }
    direction
    id
    isAccepted
    isError
    isInitiated
    isSettled
    note
    ownerNarwhalId
    serviceProviderName
    statementReference
    status
    vatAmount
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetTransferQueryVariables,
    APITypes.GetTransferQuery
>;
export const groupById = /* GraphQL */ `query GroupById($groupId: String!) {
  groupById(groupId: $groupId) {
    bills {
      amount
      createdAt
      createdBy
      currency
      groupId
      id
      name
      owings {
        amount
        avatarUrl
        currency
        firstName
        id
        narwhalId
        username
        __typename
      }
      __typename
    }
    createdAt
    id
    imageUrl
    members {
      avatarUrl
      firstName
      groupCreator
      groupId
      id
      narwhalId
      username
      __typename
    }
    name
    __typename
  }
}
` as GeneratedQuery<APITypes.GroupByIdQueryVariables, APITypes.GroupByIdQuery>;
export const groupsPerMember = /* GraphQL */ `query GroupsPerMember {
  groupsPerMember {
    bills {
      amount
      createdAt
      createdBy
      currency
      groupId
      id
      name
      owings {
        amount
        avatarUrl
        currency
        firstName
        id
        narwhalId
        username
        __typename
      }
      __typename
    }
    createdAt
    id
    imageUrl
    members {
      avatarUrl
      firstName
      groupCreator
      groupId
      id
      narwhalId
      username
      __typename
    }
    name
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GroupsPerMemberQueryVariables,
    APITypes.GroupsPerMemberQuery
>;
export const identitiesFromNarwhal = /* GraphQL */ `query IdentitiesFromNarwhal($narwhalId: String!) {
  identitiesFromNarwhal(narwhalId: $narwhalId) {
    email
    firstName
    id
    lastName
    __typename
  }
}
` as GeneratedQuery<
    APITypes.IdentitiesFromNarwhalQueryVariables,
    APITypes.IdentitiesFromNarwhalQuery
>;
export const item = /* GraphQL */ `query Item($shortCode: String!) {
  item(shortCode: $shortCode) {
    archived
    display
    displayPrice
    image
    name
    price
    quantity
    quantitySold
    questions
    shortCode
    variants {
      display
      name
      quantity
      quantitySold
      variantId
      __typename
    }
    vatRate
    __typename
  }
}
` as GeneratedQuery<APITypes.ItemQueryVariables, APITypes.ItemQuery>;
export const items = /* GraphQL */ `query Items(
  $archived: Boolean
  $combineVariants: Boolean
  $narwhalId: String!
) {
  items(
    archived: $archived
    combineVariants: $combineVariants
    narwhalId: $narwhalId
  ) {
    archived
    display
    displayPrice
    image
    name
    price
    quantity
    quantitySold
    questions
    shortCode
    variants {
      display
      name
      quantity
      quantitySold
      variantId
      __typename
    }
    vatRate
    __typename
  }
}
` as GeneratedQuery<APITypes.ItemsQueryVariables, APITypes.ItemsQuery>;
export const itemsByUsername = /* GraphQL */ `query ItemsByUsername(
  $archived: Boolean
  $combineVariants: Boolean
  $username: String!
) {
  itemsByUsername(
    archived: $archived
    combineVariants: $combineVariants
    username: $username
  ) {
    archived
    display
    displayPrice
    image
    name
    price
    quantity
    quantitySold
    questions
    shortCode
    variants {
      display
      name
      quantity
      quantitySold
      variantId
      __typename
    }
    vatRate
    __typename
  }
}
` as GeneratedQuery<
    APITypes.ItemsByUsernameQueryVariables,
    APITypes.ItemsByUsernameQuery
>;
export const lookup = /* GraphQL */ `query Lookup($email: String!) {
  lookup(email: $email) {
    emailVerified
    isSignedUp
    success
    __typename
  }
}
` as GeneratedQuery<APITypes.LookupQueryVariables, APITypes.LookupQuery>;
export const searchMerchantClaimsByClaimerName = /* GraphQL */ `query SearchMerchantClaimsByClaimerName($name: String!) {
  searchMerchantClaimsByClaimerName(name: $name) {
    claimId
    claimerEmail
    claimerName
    claimerNarwhalId
    createdAt
    image
    isPopped
    merchantName
    merchantNarwhalId
    name
    poppedAt
    shortCode
    variantId
    __typename
  }
}
` as GeneratedQuery<
    APITypes.SearchMerchantClaimsByClaimerNameQueryVariables,
    APITypes.SearchMerchantClaimsByClaimerNameQuery
>;
export const searchTransfersWithIndividuals = /* GraphQL */ `query SearchTransfersWithIndividuals($name: String!) {
  searchTransfersWithIndividuals(name: $name) {
    amount
    createdAt
    email
    id
    isAbandoned
    isAccepted
    isAuthUrlGenerated
    isAuthorised
    isCancelled
    isError
    isInitiated
    isSettled
    name
    note
    reference
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
    APITypes.SearchTransfersWithIndividualsQueryVariables,
    APITypes.SearchTransfersWithIndividualsQuery
>;
